import FirebaseConfig from "../firebaseConfig";

const db = FirebaseConfig.firestore(),
  menteeRef = db.collection("mentee");

// add value in mentee collection
export async function createMentee(data, callback) {
  let mentee = menteeRef.doc();

  mentee
    .set({
      id: mentee.id,
      status: "active",
      first_name: data.first_name,
      last_name: data.last_name,
      phone: data.phone,
      email: data.email,
      ethnicity: data.ethnicity,
      cohort_year: data.cohort_year,
      dob: data.dob,
      parent_details: {
        first_name: data.parent_details.first_name,
        last_name: data.parent_details.last_name,
        phone: data.parent_details.phone,
        email: data.parent_details.email,
      },
      gender: data.gender,
      assigned_mentor: data.assigned_mentor,
      grade_level: data.grade_level,
      school_site: data.school_site,
      created_by: localStorage.getItem("token"),
      created_at: FirebaseConfig.firestore.FieldValue.serverTimestamp(),
    })
    .then(() => {
      callback(true);
    })
    .catch(() => {
      callback(false);
    });
}

// list mentee details
export async function getMentee(callback) {
  let mentee = [];
  let query = menteeRef.get();
  const querySnapshot = await query;
  querySnapshot.forEach((doc) => {
    const {
      id,
      first_name,
      last_name,
      phone,
      email,
      ethnicity,
      cohort_year,
      assigned_mentor,
      gender,
      dob,
      parent_details,
      grade_level,
      school_site,
      created_at,
      created_by,
      status,
    } = doc.data();
    mentee.push({
      key: doc.id,
      id,
      first_name,
      last_name,
      phone,
      email,
      ethnicity,
      dob,
      parent_details,
      school_site,
      grade_level,
      cohort_year,
      gender,
      assigned_mentor,
      created_by,
      created_at,
      status,
    });
  });
  return mentee;
}

export async function getMentees(callback) {
  let mentee = [];
  menteeRef.get().then((querySnapshot) => {
    querySnapshot.forEach((doc) => {
      const {
        id,
        first_name,
        last_name,
        phone,
        email,
        ethnicity,
        cohort_year,
        assigned_mentor,
        gender,
        dob,
        parent_details,
        grade_level,
        school_site,
        created_at,
        created_by,
        status,
      } = doc.data();
      mentee.push({
        key: doc.id,
        id,
        first_name,
        last_name,
        phone,
        email,
        ethnicity,
        dob,
        parent_details,
        school_site,
        grade_level,
        cohort_year,
        gender,
        assigned_mentor,
        created_by,
        created_at,
        status,
      });
    });
    callback(mentee);
  });
}

export async function getAssignedMentees(idd, callback) {
  let mentee = [];
  menteeRef
    .where("assigned_mentor", "==", idd)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const {
          id,
          first_name,
          last_name,
          phone,
          email,
          ethnicity,
          cohort_year,
          assigned_mentor,
          gender,
          dob,
          parent_details,
          grade_level,
          school_site,
          created_at,
          created_by,
          status,
        } = doc.data();
        mentee.push({
          key: doc.id,
          id,
          first_name,
          last_name,
          phone,
          email,
          ethnicity,
          dob,
          parent_details,
          school_site,
          grade_level,
          cohort_year,
          gender,
          assigned_mentor,
          created_by,
          created_at,
          status,
        });
      });
      callback(mentee);
    });
}

export async function getMenteeDetails(data, callback) {
  let menteedoc = menteeRef.doc(data);
  menteedoc
    .get()
    .then((doc) => {
      if (doc.exists) {
        callback(doc.data(), true);
      }
    })
    .catch((error) => {
      callback({}, false);
    });
}

export async function removeMentee(userId, callback) {
  try {
    await menteeRef.doc(userId).delete();
    callback({}, true);
  } catch (error) {
    console.log(error);
    callback({}, false);
  }
}
export async function updateStatusMentee(data, status, callback) {
  try {
    await menteeRef.doc(data.id).set({
      ...data,
      status: status,
    });
    callback({}, true);
  } catch (error) {
    callback({}, false);
  }
}
